import {observer} from "mobx-react";
import React from "react";
import ModalInformation from "@dropDesk/presentation/components/modals/modal_information";
import {useBetween} from "use-between";
import {ICONS_DROPDESK} from "@dropDesk/storage/icons/icons.d";
import {useModalConfirmAccount} from "@dropDesk/presentation/pages/confirm_account/ui/modals/handle_change_visible";

const ModalsConfirmAccount = observer(
    ({
         onRememberThisDevice,
         loading,
     }: {
        onRememberThisDevice: () => void,
        loading: boolean,
    }) => {

        const {
            visibleModalRememberThisDevice, setVisibleModalRememberThisDevice
        } = useBetween(useModalConfirmAccount);

        return (
            <ModalInformation
                open={visibleModalRememberThisDevice}
                onRequestClose={() => {
                    setVisibleModalRememberThisDevice(false);
                }}
                textHeaderModal={'Confiar neste navegador'}
                textButton={'Confiar'}
                onRequestSave={async () => {
                    onRememberThisDevice();
                    setVisibleModalRememberThisDevice(false);
                }}
                nameIcon={ICONS_DROPDESK.info}
                sizeIcon={115}
                textInformation={`
                Ao selecionar “Confiar neste navegador por 1 mês”, o login poderá ser feito sem solicitar o código de verificação neste navegador.
                Use apenas em dispositivos pessoais, você pode remover essa confiança a qualquer momento limpando cookies/dados do site
                `}
                loading={loading}
            />
        )
    })
export default ModalsConfirmAccount;
